/**
 * Object containing endpoint paths used in the application.
 * These should be appended to the BASE_URL to form full URLs.
 * @constant
 * @type {{ RECORD_EXPERIMENT: string }}
 * @property {string} RECORD_EXPERIMENT - The endpoint to record experiment analytics data.
 * @example
 * const url = `${BASE_URL}${ENDPOINTS.RECORD_EXPERIMENT}`;
 */
export const ENDPOINTS = {
  RECORD_EXPERIMENT: 'core-analytics/universal/experiments/record',
}
